/**
 * t -> tracker PROD
 * td -> tracker DEV
 * trc -> tracker RC
 */
export default class SqzlTransmit {
    #sqzlTestMode = typeof sqzlUnitTest !== 'undefined';
    g = null;
    url = 'https://t.squeezely.tech/t';
    dynamicBaseUrl = 'https://squeezely.tech';
    rawEventTracking = false;
    googleConversionId = false;
    googleConversionLabel = false;
    urlCustomFields = false;
    createdCookie = false;
    fbPixelInited = false;
    constants = {
        mainCookieName: 'sqzllocal',
        sessionCookieName: 'sqzl_session_id',
        piiFields: {},
        // @see https://support.google.com/analytics/answer/6205902#supported-currencies
        gaSupportedCurrencies: { USD: true, AED: true, ARS: true, AUD: true, BGN: true, BOB: true, BRL: true, CAD: true, CHF: true, CLP: true, CNY: true, COP: true, CZK: true, DKK: true, EGP: true, EUR: true, FRF: true, GBP: true, HKD: true, HRK: true, HUF: true, IDR: true, ILS: true, INR: true, JPY: true, KRW: true, LTL: true, MAD: true, MXN: true, MYR: true, NOK: true, NZD: true, PEN: true, PHP: true, PKR: true, PLN: true, RON: true, RSD: true, RUB: true, SAR: true, SEK: true, SGD: true, THB: true, TRY: true, TWD: true, UAH: true, VEF: true, VND: true, ZAR: true }
    };
    settings = {
        useSSL: 'https:' === document.location.protocol,
        // baseJSPath: '',
        anonymous: false,
        sessionId: '',
        ga: {
            gaObject: null,
            categoryName: 'SqueezelyEvent',
            trackerName: 'sqzlGaTracker',
            ua: '',
            events: {}
        },
        ga4: {
            events: {},
            passPersonalizationNames: false
        }
    };
    state = {
        sessionEventHandled: false,
        dataLayerEventsLoaded: false,
        gtagLoaded: {},
        gaLoaded: {
            initialized: false,
            enabled: false
        },
        gptLoaded: {
            initialized: false
        }
    };
    trackerEnabled = true;
    capiMerchant = false;
    smartTrackingEnabled = false;
    merchantCurrency = false;
    duplicateEventTracker = [];
    /**
     * Array with all callbacks listeners
     * @type {Array}
     */
    eventCallbacks = [];
    /**
     * Array with the events that are fired (to avoid onload/onreadystatechange firing the same event)
     * @type {Array}
     */
    eventCallbacksFired = [];

    metaEventForwardingFilterEnabled = false;
    metaEventForwardingEventFilter = [];

    constructor() {
        sqzlCommon.g.sqzlTransmit = this;
        this.g = sqzlCommon.g;

        // @todo Move these to common.js
        this.g.sqzl = this.g.sqzl || [];
        this.g.sqzl.q = this.g.sqzl.q || [];
        // Personalization queue
        this.g.sqzl.p = this.g.sqzl.p || [];
        this.g.dataLayer = this.g.dataLayer || [];

        this.settings.ga.gaObject = this.g.GoogleAnalyticsObject || 'ga';
    }

    getConstants() {
        return this.constants;
    }

    init() {
        this.bindErrorHandler();

        var gtCfg = sqzlCommon.getConfigItem.bind(sqzlCommon),
            dynamicBaseUrlCfg = gtCfg('sqzlDynamicBaseUrl'),
            urlCfg = gtCfg('sqzlTrackingUrl');
        if(dynamicBaseUrlCfg) {
            this.dynamicBaseUrl = dynamicBaseUrlCfg;
        }
        if(urlCfg) { this.url = urlCfg; }
        this.rawEventTracking = gtCfg('sqzlRawEventTracking', false);
        this.trackerEnabled = gtCfg('sqzlTrackerEnabled', true);
        this.capiMerchant = gtCfg('sqzlCapiMerchant', false);
        this.smartTrackingEnabled = gtCfg('sqzlSmartTracking', false);
        this.merchantCurrency = gtCfg('merchant_currency', 'EUR');
        this.constants.piiFields = gtCfg('sqzlPiiFields', {});
        this.urlCustomFields = gtCfg('sqzlUrlCustomFields', false);
        this.googleConversionId = gtCfg('sqzlGoogleConversionId', false);
        this.googleConversionLabel = gtCfg('sqzlGoogleConversionLabel', false);
        this.metaEventFilterEnabled = gtCfg('sqzlMetaEventFilterEnabled', false);
        this.metaEventFilter = gtCfg('sqzlMetaEventFilter', []);

        if(sqzlCommon.hasConsentManagementEnabled()) {
            // Default to no consent when enabled
            if(sqzlCommon.getDebugLevel()) {
                // The actual setting happens in sqzlCommon in the settings..
                console.log('sqzly: Consent management enabled, setting default consent to none');
            }
        }

        // if(typeof sqzlLoaderFiles !== 'undefined') {
        //     var srcElement = sqzlLoaderFiles[Object.keys(sqzlLoaderFiles)[0]];
        //     if(typeof srcElement !== 'undefined' && srcElement !== null) {
        //         this.setBaseJSPath(srcElement.src.replace(/[^\/]+\.js$/gi, ''));
        //     }
        // }

        if(this.trackerEnabled) {
            // This is here to store the cookie in local storage.
            // Or to fetch it from local storage and put it back into the cookie.
            sqzlCommon.readConsentCookie();

            this.addPersonalizationCallback();
            this.addSqzlListeners();
            this.checkSqzl();
        }

        // @todo We might want to unshift this in the future instead (But it needs overloaded unshift next to push in this case)
        this.g.sqzl.q.push([{
            ExecuteConsentCallback: this.loadDsps,
            has: ['marketing']
        }]);
        this.loadSooqr();

        this.loadDataLayer(true);
    }

    bindErrorHandler() {
        try {
            if(Element.prototype.addEventListener) {
                // Capture all other errors as well, for newer browsers, older browsers might not send error events, but we already have enough debug data with newer ones
                let handler = function(e) {
                    if(typeof e.filename === 'string' && e.filename !== '' && e.filename.match(/SQ-2565/)) {
                        // Skip non sqzly errors
                        sqzlCommon.sqzlException(e);
                    }
                }.bind(this);

                this.g.addEventListener('error', handler);
            }
        } catch(e) {}
    }

    // /**
    //  * @param path {string}
    //  */
    // setBaseJSPath(path) {
    //     this.settings.baseJSPath = path;
    // }

    // /**
    //  * @returns {string}
    //  */
    // getBaseJSPath() {
    //     return this.settings.baseJSPath;
    // }

    /**
     * @callback
     */
    checkSqzl() {
        if(
            this.trackerEnabled &&
            typeof this.g.sqzl !== 'undefined' &&
            typeof this.g.sqzl.q !== 'undefined' &&
            this.g.sqzl.q && this.g.sqzl.q.length > 0 &&
            sqzlCommon.getConfigItem('sqzlAccount')
        ) {
            //send session when we get an event.
            this.checkSession();

            var trackItems = this.g.sqzl.q;
            this.SQZLOldQueueWatcher.resetItems();
            var consentChanged = false;

            for(var i = 0; i < trackItems.length; i++) {
                var data = [];

                // clone the trackItems, to keep the dataLayer clean

                //first check if its a passthru from fbq()
                var isFBQCall = trackItems[i] instanceof Array &&
                    (trackItems[i].fb_capi || (trackItems[i][0] && trackItems[i][0].fb_capi)) //fb can send in trackItem or (on init) in [0]

                if(isFBQCall) {
                    var trackItem = (trackItems[i][0] && trackItems[i][0].fb_capi) ? trackItems[i][0] : trackItems[i];
                    data = this.parseFacebookEvent(Object.assign({}, trackItem));
                    if(data === false) {
                        delete trackItems[i];
                        continue;
                    }
                }
                else if(trackItems[i] instanceof Object) {
                    if(typeof trackItems[i].callee === 'function' || typeof trackItems[i][0] !== 'undefined') { // Arguments class, old style sqzl()
                        data = Object.assign({}, trackItems[i][0]);
                    }
                    else {
                        data = Object.assign({}, trackItems[i]);
                    }
                }
                else { // new style
                    data = Object.assign({}, trackItems[i]);
                }
                data.log_id = sqzlCommon.uuidv4();

                if(sqzlCommon.isDebugEnabled()) {
                    console.info('sqzly: EVENT', data);
                }

                if(data.hasOwnProperty('SetCallback')) {
                    this.eventCallbacks.push({'callbackFunction': data.SetCallback});

                    if(sqzlCommon.isDebugEnabled()) {
                        console.debug('sqzly: Additional callback set');
                    }
                    delete trackItems[i];
                    continue;
                }

                if(data.hasOwnProperty('ExecuteConsentCallback')) {
                    if(
                        !sqzlConsentManagementEnabled ||
                        (
                            data.hasOwnProperty('has') &&
                            sqzlCommon.intersect(data.has, sqzlCommon.getConsent()).length > 0
                        )
                    ) {
                        data.ExecuteConsentCallback.call(this);
                        delete trackItems[i];
                    }
                    continue;
                }

                // Make sure logData is a clone without references
                var logData = Object.assign({}, data);

                try {
                    if(typeof data === 'object' && typeof data.anonymize !== 'undefined') {
                        if(typeof data.anonymize !== 'number') {
                            data.anonymize = data.anonymize.toLowerCase();
                        }

                        sqzlCommon.setAnonymous(
                            (data.anonymize === 'on' || data.anonymize === 'yes' || data.anonymize === 'enabled' || data.anonymize === '1' || data.anonymize === 1)
                        );

                        // Anonymous enabled or disabled, remove this event
                        delete trackItems[i];
                        continue;
                    }

                    if(typeof data === 'object' && typeof data.consent !== 'undefined') {
                        // Reformat the data to fit the event format
                        var consentEventObject = {
                            event: "Consent",
                            user_interaction: false,
                            status: data.consent
                        };

                        if(
                            data.hasOwnProperty('user_interaction') && typeof data.user_interaction === 'boolean' &&
                            data.user_interaction === true
                        ) {
                            consentEventObject.user_interaction = true;
                        }

                        if((typeof data.permissions === 'object' || typeof data.permissions === 'string') && typeof data.permissions !== 'undefined') {
                            if(typeof data.permissions === 'string') {
                                // If someone doesn't send us an array but a string, just handle the event to see if it contains valid permissions and handle it anyway
                                data.permissions = [data.permissions];
                            }

                            consentEventObject.permissions = data.permissions;
                        }
                        this.handleEvent.handleEvent(consentEventObject);
                        consentChanged = true;
                        // Consent given or revoked, remove this event
                        delete trackItems[i];
                        continue;
                    }

                    if(
                        sqzlCommon.getConsent().length === 0 &&
                        !(
                            // We always need to send user interaction pixel consent events
                            data.hasOwnProperty('event') &&
                            (data.event === 'RevokeConsentAnalytics' || data.event === 'RevokeConsentMarketing')
                        )
                    ) {
                        continue;
                    }

                    if(this.isBlackListed(data)) {
                        continue;
                    }

                    var sendSqzlyPixel = true;
                    // SqueezelyAudience has a special attribute to be skipped for our own pixel
                    if(typeof data === 'object' && data.hasOwnProperty('b253d5e8')) {
                        sendSqzlyPixel = false;
                    }

                    // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!
                    data.cookie = this.getMainCookie();
                    data.merchantid = sqzlCommon.getConfigItem('sqzlAccount');
                    data.event = data.event ? data.event.trim() : 'PageView';
                    if(sqzlCommon.getDataCenter()) {
                        data.datacenter = sqzlCommon.getDataCenter();
                    }
                    data.platform = this.getPlatform(data.platform);
                    data.device = sqzlCommon.isMobileBrowser() ? 'mobile' : 'desktop';
                    if(typeof data.product_ids === 'undefined' && typeof data.products !== 'undefined') {
                        data.product_ids = [];
                        if(!Array.isArray(data.products) && typeof data.products.id !== 'undefined') {
                            data.product_ids.push(typeof data.products.id === 'string' ? data.products.id.trim() : data.products.id);
                        }
                        else if(Array.isArray(data.products)) {
                            data.products.forEach(function(product) {
                                if(typeof product.id !== 'undefined') {
                                    data.product_ids.push(typeof product.id === 'string' ? product.id.trim() : product.id);
                                }
                            });
                        }
                    }
                    // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!
                    if(typeof data.timestamp === 'undefined') {
                        data.timestamp = Math.round(+new Date() / 1000);
                    }

                    // Extract URL parameters
                    var urlParams = {};
                    if(this.getURLParameter('utm_source')) {
                        urlParams.utm_source = this.getURLParameter('utm_source');
                    }
                    if(this.getURLParameter('utm_campaign')) {
                        urlParams.utm_campaign = this.getURLParameter('utm_campaign');
                    }
                    if(this.getURLParameter('sqzl_source')) {
                        urlParams.sqzl_source = this.getURLParameter('sqzl_source');
                    }
                    if(this.getURLParameter('sqzl_campaign')) {
                        urlParams.sqzl_campaign = this.getURLParameter('sqzl_campaign');
                    }
                    // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!
                    if(this.getURLParameter('email') && (typeof data.email_hash === 'undefined' || data.email_hash === '')) {
                        urlParams.email_hash = this.getURLParameter('email');
                    }
                    if(this.getURLParameter('email_hash') && ((typeof data.email === 'undefined' || data.email === '') && (typeof data.email_hash === 'undefined' || data.email_hash === ''))) {
                        urlParams.email_hash = this.getURLParameter('email_hash');
                    }
                    if (this.getURLParameter('userid')) {
                        // If empty in data set as userid
                        if ((typeof data.userid === 'undefined' || data.userid === '')) {
                            urlParams.userid = this.getURLParameter('userid');
                        }
                        // Use from data for Logging
                        else {
                            urlParams.userid = data.userid;
                        }
                    }
                    // This could have been defined before the ulrParam
                    if(typeof data.user_id !== 'undefined') {
                        urlParams.userid = data.user_id;
                    }

                    // Merge URL parameters into data & with logData
                    Object.assign(data, urlParams);
                    Object.assign(logData, urlParams);

                    if((data.event === 'Purchase' || data.event === 'ViewContent' || data.event === 'AddToCart') && typeof data.currency === 'undefined') {
                        data.currency = this.merchantCurrency;
                    }

                    data.frontend_event_id = data.frontend_event_id || sqzlCommon.uniqid('sqfei');
                    if(data.event.toLowerCase() === 'purchase' && typeof data.orderid !== 'undefined' && data.orderid) {
                        data.frontend_event_id = data.orderid;
                    }
                    data.user_agent = this.getUserAgent();
                    data.fbp = sqzlCommon.readCookie('_fbp'); //facebook cookie
                    data.fbc = sqzlCommon.readCookie('_fbc'); //facebook cookie

                    if(sqzlCommon.isAnonymous()) {
                        data.aip = 1;
                    }
                    // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!
                    if(!data.url) {
                        data.url = this.g.location.href;
                    }
                    data.session_id = this.settings.sessionId;
                    if(this.urlCustomFields) {
                        for(var customFieldIterator in this.urlCustomFields) {
                            if (this.urlCustomFields.hasOwnProperty(customFieldIterator)) {
                                var urlCustomParameter = this.urlCustomFields[customFieldIterator];
                                if (this.getURLParameter(urlCustomParameter) && (typeof data[urlCustomParameter] === 'undefined' || data[urlCustomParameter] === '')) {
                                    data[urlCustomParameter] = this.getURLParameter(urlCustomParameter);
                                }
                            }
                        }
                    }

                    if(data.merchantid) {
                        if(typeof data.totalvalue === 'undefined' && typeof data.products !== 'undefined') {
                            var totalvalue = 0;

                            if(!Array.isArray(data.products) && typeof data.products.price !== 'undefined') {
                                totalvalue = data.products.price;
                            }
                            else if(Array.isArray(data.products)) {
                                data.products.forEach(function(product) {
                                    var quantity = 1;

                                    if(typeof product.quantity !== 'undefined' && product.quantity > 0) quantity = product.quantity;
                                    if(typeof product.price !== 'undefined') {
                                        totalvalue += product.price * quantity;
                                    }
                                });
                            }

                            // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!

                            if(totalvalue > 0) {
                                data.totalvalue = totalvalue;
                            }
                        }

                        if(sqzlCommon.hasConsentManagementEnabled()) {
                            data.consent = sqzlCommon.getConsent().toString();
                        }
                        else {
                            data.consent = 'disabled';
                        }

                        // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!

                        if(typeof data === 'object') {
                            data = this.filterData(data);
                            data = this.formatTravelData(data);
                        }

                        if(typeof data.checkin_date !== 'undefined') {
                            try {
                                localStorage.setItem('checkin_date', data.checkin_date);
                            }
                            catch(error) {
                                // Ignore for now, to avoid QuotaExceededError
                            }
                        }
                        if(typeof data.amount_nights !== 'undefined') {
                            try {
                                localStorage.setItem('amount_nights', data.amount_nights);
                            }
                            catch(error) {
                                // Ignore for now, to avoid QuotaExceededError
                            }
                        }

                        var isDuplicate = this.isDuplicateEvent(data),
                            eventHandled = false,
                            hceData = false;
                        if(isDuplicate) eventHandled = true;
                        if(
                            !this.capiMerchant && this.rawEventTracking && sendSqzlyPixel &&
                            (
                                sqzlCommon.hasAnalyticsConsent() ||
                                sqzlCommon.hasMarketingConsent() ||
                                // We always need to send user interaction pixel consent events
                                data.event === 'RevokeConsentAnalytics' ||
                                data.event === 'RevokeConsentMarketing'
                            )
                        ) {
                            logData = this.formatLogData(logData);
                            if(logData) {
                                hceData = logData;
                            }
                        }

                        if(
                            (
                                sqzlCommon.hasAnalyticsConsent() ||
                                // We always need to send user interaction pixel consent events
                                (data.event === 'RevokeConsentAnalytics' || data.event === 'RevokeConsentMarketing')
                            ) &&
                            !isDuplicate
                        ) {
                            if(sqzlCommon.isDebugEnabled()) {
                                console.debug('sqzly: Loading analytics event', data);
                            }
                            if(sendSqzlyPixel) {
                                this.loadAws(data, hceData);

                                if(data.event === 'SessionStart') {
                                    sqzlCommon.createCookie(this.constants.sessionCookieName, data.session_id + '|' + (Date.now() / 1000), 1 / 48); //30 minutes

                                    this.cookieSync();
                                }
                            }
                            eventHandled = true;
                        }

                        if(
                            !isDuplicate &&
                            !(
                                // Do not forward user interaction pixel consent events
                                data.hasOwnProperty('event') &&
                                (data.event === 'RevokeConsentAnalytics' || data.event === 'RevokeConsentMarketing')
                            )
                        ) {
                            this.loadEventForward(data);
                        }

                        // Note: If you add fields to data that are not original fields from the sqzl() call, add them to EventStats::FILTER_RAW_REQUEST_FIELDS, please!
                        data = this.parseCustomFields(data);
                        if(
                            (
                                sqzlCommon.hasMarketingConsent() &&
                                !(
                                    // Do not send user interaction pixel consent events
                                    data.hasOwnProperty('event') &&
                                    (data.event === 'RevokeConsentAnalytics' || data.event === 'RevokeConsentMarketing')
                                )
                            ) &&
                            !isDuplicate
                        ) {
                            if(sqzlCommon.isDebugEnabled()) {
                                console.debug('sqzly: Loading marketing event', data);
                            }

                            if (!this.metaEventFilterEnabled || this.metaEventFilter.includes(data?.event)) {
                                this.loadFacebookPixel(data);
                            }

                            this.loadGoogleGtag(data);
                            this.loadFloodlight(data);
                            eventHandled = true;
                        }

                        if(eventHandled) {
                            // Event was handled, remove it from the list
                            delete trackItems[i];
                        }
                    }
                    else {
                        console.warn('sqzly: Account id not set..');
                    }
                }
                catch(e) {
                    if(sqzlCommon.getDebugLevel()) {
                        console.error('sqzly: EVENT ERROR', trackItems[i]);
                    }
                    if(this.g.hasOwnProperty('sqzlUnitTest')) {
                        throw e;
                    }

                    sqzlCommon.sqzlException(e, data);
                    var errorEvent = '';
                    if(data.hasOwnProperty('event')) {
                        errorEvent += ' ' + data.event;
                    }
                    else if(data.hasOwnProperty('consent')) {
                        errorEvent += ' consent-' + data.consent;
                    }

                    // Remove the event that generated the error, or it'll keep looping indefinitely
                    delete trackItems[i];

                    console.error('sqzly: failed to send event' + errorEvent, e);
                }
            }

            if(trackItems.length > 0) {
                // Reset the array, might have gaps because of deletions
                trackItems = trackItems.filter(function(item) {
                    return item !== undefined;
                });

                // Re-queue items, and make sure any new items not yet handled are not lost
                this.g.sqzl.q = trackItems.concat(this.g.sqzl.q);
                this.SQZLOldQueueWatcher.forceOverwritePush();

                if(consentChanged) {
                    this.checkSqzl();
                }
            }
        }

        if(typeof console !== 'undefined' && !this.trackerEnabled && !this.#sqzlTestMode) {
            console.warn('Squeezely tracker disabled. Please contact support@squeezely.tech');
        }
    }

    /**
     * get session id from cookie and if not found fire session event
     *
     * @return {boolean}
     */
    checkSession() {
        if(this.capiMerchant) {
            return false; //no sessionStart event
        }
        if(!this.state.sessionEventHandled) {
            let sessionId = null;

            const sessionIdWithTimestamp = sqzlCommon.readCookie(this.constants.sessionCookieName);
            if(sessionIdWithTimestamp) {
                const sessionIdParts = sessionIdWithTimestamp.split('|');
                if(sessionIdParts.length > 1 && parseInt(sessionIdParts[1]) > ((Date.now() / 1000) - 1800)) {
                    sessionId = sessionIdParts[0];
                }
                else {
                    sessionId = false;
                }
            }

            if(!sessionId) {
                sessionId = sqzlCommon.uniqid();

                this.settings.sessionId = sessionId;
                this.state.sessionEventHandled = true; // set on true, to avoid the endless loops if q.push() sends a SessionStart
                this.g.sqzl.q.unshift([
                    {
                        event : "SessionStart"
                    }
                ]);
            }
            this.settings.sessionId = sessionId;
            this.state.sessionEventHandled = true;

            return this.checkedSession(true);
        }

        return false;
    }

    /**
     * @param {boolean} state
     * @return {boolean}
     */
    checkedSession(state) {
        return true;
    }

    /**
     * @param {Object} data
     * @returns {Object}
     */
    filterData(data) {
        if(sqzlCommon.isAnonymous()) {
            // Filter out PII fields if required
            data = this.filterPiiData(data);
        }

        // Filter out products from personalization view/click events
        data = this.filterPersonalizationStatisticsEventData(data);

        // CRC32(skipSqzlPixel) = b253d5e8
        if(data.hasOwnProperty('b253d5e8')) {
            delete data['b253d5e8'];
        }

        return data;
    }

    /**
     * @param {Object} data
     *
     * @returns {Object}
     */
    formatTravelData(data) {
        if(typeof data.checkindate !== 'undefined' && typeof data.checkin_date === 'undefined') {
            data.checkin_date = data.checkindate;
            delete data.checkindate;
        }
        if(typeof data.checkoutdate !== 'undefined' && typeof data.checkout_date === 'undefined') {
            data.checkout_date = data.checkoutdate;
            delete data.checkoutdate;
        }

        if(
            typeof data.checkin_date !== 'undefined' &&
            isNaN((new Date(data.checkin_date.replace(/(\d{4}(-\d{2}){2})\s*(\d{2}(:\d{2}){1,2})/g, '$1T$3'))).getDay())
        ) {
            delete data.checkin_date;
        }
        if(
            typeof data.checkout_date !== 'undefined' &&
            isNaN((new Date(data.checkout_date.replace(/(\d{4}(-\d{2}){2})\s*(\d{2}(:\d{2}){1,2})/g, '$1T$3'))).getDay())
        ) {
            delete data.checkout_date;
        }
        if(
            typeof data.amount_nights !== 'undefined' &&
            isNaN(parseInt(data.amount_nights))
        ) {
            // Invalid amount nights, we can't use this for calculations
            delete data.amount_nights;
        }

        if(
            typeof data.checkin_date !== 'undefined' &&
            typeof data.checkout_date !== 'undefined' && typeof data.amount_nights === 'undefined'
        ) {
            // Checkin date known, checkout date known, amount nights unknown
            // We can calculate the amount of nights
            data.amount_nights = Math.ceil(Math.abs((new Date(data.checkin_date)) - (new Date(data.checkout_date))) / 86400000)
        }
        else if(
            typeof data.checkin_date === 'undefined' &&
            typeof data.checkout_date !== 'undefined' && typeof data.amount_nights !== 'undefined'
        ) {
            // Checkin date unknown, checkout date known, amount nights known
            // We can calculate the checkin date
            var dateObject = new Date(data.checkout_date);
            dateObject.setDate(dateObject.getDate() - data.amount_nights);
            data.checkin_date = this.dateToIso8601String(dateObject);
        }
        // else if(
        //     typeof data.checkin_date === 'undefined' &&
        //     typeof data.checkout_date !== 'undefined' && typeof data.amount_nights === 'undefined'
        // ) {
        //     // Checkin date unknown, checkout date known, amount nights unknown
        //     // We cannot handle this, as we cannot convert this to the two fields that are stored.
        // }

        // checkout_date is ignored internally, but might be useful for an event forward so leave it in, please

        return data;
    }

    /**
     * @param {Object} data
     * @returns {Object}
     */
    filterPiiData(data) {
        for(var i in data) {
            if(data.hasOwnProperty(i)) {
                if(this.getConstants().piiFields.hasOwnProperty(i)) {
                    delete data[i];
                }
                if(this.getConstants().piiFields.hasOwnProperty(i.toLowerCase())) {
                    delete data[i.toLowerCase()];
                }
            }
        }

        return data;
    }

    /**
     * We want to keep the fields intact, so we know they where there, we just don't want the data.
     *
     * @param {Object} data
     * @returns {Object}
     */
    emptyPiiData(data) {
        for(var i in data) {
            if(data.hasOwnProperty(i)) {
                if(this.getConstants().piiFields.hasOwnProperty(i)) {
                    data[i] = '';
                }
                if(this.getConstants().piiFields.hasOwnProperty(i.toLowerCase())) {
                    data[i.toLowerCase()] = '';
                }
            }
        }

        return data;
    }

    /**
     * Filter out any products from personalization view events (click is ok).
     * We don't want to act on this product data, we just want the products to be available in frontend callback hooks.
     *
     * @param {Object} data
     * @returns {Object}
     */
    filterPersonalizationStatisticsEventData(data) {
        if(
            data.hasOwnProperty('event') &&
            data.event === 'PersonalizationView' &&
            data.hasOwnProperty('products')
        ) {
            delete data['products'];
        }

        return data;
    }

    /**
     * @param {Array} [permissions]
     */
    grantConsent(permissions) {
        if(!sqzlCommon.hasConsentManagementEnabled()) {
            console.warn('Customer consent management is not yet enabled. Please enable it in Squeezely Settings');
            return;
        }

        sqzlCommon.grantConsent(permissions);

        this.checkSqzl();
    }

    /**
     * @param {Array} [permissions]
     * @param {Bool} userInteraction
     */
    revokeConsent(permissions, userInteraction) {
        if(!sqzlCommon.hasConsentManagementEnabled()) {
            console.warn('Customer consent management is not yet enabled. Please enable it in Squeezely Settings');
            return;
        }

        var validatedPermissions = sqzlCommon.revokeConsent(permissions);

        if(typeof userInteraction === 'boolean' && userInteraction === true) {
            // We need to send the revoke cookie consent pixel(s) so it'll show up in the consent logs
            // Doing this using separate events instead of reusing the consents column makes sure
            // we will never have a collision with existing consent handling code
            for(var i in validatedPermissions) {
                if(validatedPermissions.hasOwnProperty(i)) {
                    switch(validatedPermissions[i]) {
                        case 'analytics':
                            this.g.sqzl.q.push([{
                                event : "RevokeConsentAnalytics",
                            }]);
                            break;
                        case 'marketing':
                            this.g.sqzl.q.push([{
                                event : "RevokeConsentMarketing",
                            }]);
                            break;
                        default:
                            console.error('sqzly: Unknown consentType (' + validatedPermissions[i] + ')');
                            break;
                    }
                }
            }
        }
    }

    /**
     * @returns {boolean}
     */
    isBlackListed(data, url) {
        var blackList = [/appspot\.com/];

        if(typeof url === 'undefined' || !url) {
            url = this.g.location.href || '';
        }

        for(var i = 0; i < blackList.length; i++) {
            if(url.match(blackList[i])) {
                return true;
            }
        }

        return false;
    }

    parseCustomFields(data) {
        var dateCustomFields = sqzlCommon.getConfigItem('sqzlDateCustomFields');
        if(dateCustomFields) {
            for(var key in data) {
                if (!data.hasOwnProperty(key)) continue;
                if(dateCustomFields.hasOwnProperty(key)) {
                    try {
                        var moment = new Date(data[key]);
                        data[key] = +moment;
                    }
                    catch(err) {
                        //failed to convert to timestamp
                    }
                }
            }
        }

        return data;
    }

    loadDataLayer(loadOnce) {
        if(this.capiMerchant) {
            return false; //no datalayer for capi merchants.
        }
        //add data we already have
        var productSets = sqzlCommon.getConfigItem('sqzlProductSets', []);
        if(productSets instanceof Object && Object.keys(productSets).length) {
            for(var k in productSets) {
                if(productSets.hasOwnProperty(k)) {
                    this.setDatalayer({
                        event: 'sqzl_productset',
                        product_set_id: k,
                        product_set_data: productSets[k]
                    });
                }
            }
        }

        if(!sqzlCommon.hasConsentManagementEnabled() || sqzlCommon.hasAnalyticsConsent()) {
            if(!loadOnce) {
                this.state.dataLayerEventsLoaded = false;
            }

            this.loadDataLayerEvents();
        }
    }

    loadDataLayerEvents() {
        if(this.state.dataLayerEventsLoaded === true) {
            return;
        }

        this.state.dataLayerEventsLoaded = true;

        if(sqzlCommon.isDebugEnabled()) {
            console.debug('sqzly: Loading dataLayer events');
        }

        if(sqzlCommon.getConfigItem('noJSONP', false)) {
            let jsonUrl = this.dynamicBaseUrl + '/d?cookie=' + this.getMainCookie() + '&no_jsonp=true&merchant_id=' + sqzlCommon.getConfigItem('sqzlAccount');

            if(sqzlCommon.getDebugLevel()) {
                jsonUrl = jsonUrl + '&_sqzl_debug=' + sqzlCommon.getDebugLevel();
            }
            if(sqzlCommon.getDataCenter()) {
                jsonUrl = jsonUrl + '&datacenter=' + sqzlCommon.getDataCenter();
            }

            sqzlCommon.fetchJson(jsonUrl,
                null,
                null,
                function(jsonResponse) {
                    jsonResponse.forEach(function(data) {
                        this.setDatalayer(data);
                        if(data.hasOwnProperty('event') && data.event === 'sqzl_customer_audiences') {
                            this.g.sqzl.q.push(data);
                        }
                    }.bind(this))
                },
                function(error) {
                    sqzlCommon.sqzlException(error);
                }.bind(this));
        }
        else {
            var script = this.g.document.createElement("script");
            script.src = this.dynamicBaseUrl + '/d?cookie=' + this.getMainCookie() + '&merchant_id=' + sqzlCommon.getConfigItem('sqzlAccount');
            script.async = 1;

            if(sqzlCommon.getDebugLevel()) {
                script.src = script.src + '&_sqzl_debug=' + sqzlCommon.getDebugLevel();
            }
            if(sqzlCommon.getDataCenter()) {
                script.src = script.src + '&datacenter=' + sqzlCommon.getDataCenter();
            }

            sqzlCommon.appendElementToPage(script);
        }
    }

    gtag() {
        this.g.dataLayer.push(arguments);
    }

    /**
     * Send a google ad manager google publisher tag
     */
    gpt() {
        this.g.googletag.cmd.push(arguments);
    }

    setDatalayer(data) {
        this.g.dataLayer.push(data);
    }

    loadSooqr() {
        const sooqrSettings = sqzlCommon.getConfigItem('sooqr', false);

        if(sooqrSettings && sooqrSettings.fieldId && sooqrSettings.sooqrId && sooqrSettings.locale) {
            try {
                let _wssq = _wssq || [];
                let setResizeFunction= false;
                let sooqrAccount = sooqrSettings.sooqrId;

                _wssq.push(['_load', { 'suggest' : { 'account' : 'SQ-' + sooqrAccount, 'version' : 4, fieldId : sooqrSettings.fieldId}}]);
                _wssq.push(['suggest._setPosition', 'screen-middle', {top:0}]);
                _wssq.push(['suggest._setLocale', sooqrSettings.locale]);
                _wssq.push(['suggest._excludePlaceholders', 'Search..']);
                _wssq.push(['suggest._bindEvent', 'open', function() {
                    if(!setResizeFunction) {$jQ(this.g).resize(function() {if($jQ('.sooqrSearchContainer-' + sooqrAccount).is(':visible'))
                    {websight.sooqr.instances['SQ-' + sooqrAccount].positionContainer(null, null, true);}});setResizeFunction = true;}
                }.bind(this)]);

                (function() {
                    var ws = document.createElement('script'); ws.type = 'text/javascript'; ws.async = true;
                    ws.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'static.sooqr.com/sooqr.js';
                    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ws, s);
                })();
            }
            catch(error) {
                console.error('Failed loading Sooqr');
            }
        }
    }

    loadDsps() {
        if(sqzlCommon.getConfigItem('sqzlCriteoGumCallerId')) {
            var criteoJs = this.g.document.createElement("script");
            criteoJs.type = "application/javascript";
            criteoJs.src = "https://gum.criteo.com/sync?c=" + sqzlCommon.getConfigItem('sqzlCriteoGumCallerId') + "&r=2&j=sqzlTransmit.criteoCallback";
            sqzlCommon.appendElementToPage(criteoJs);
        }
    }

    criteoCallback(data) {
        if(data.status === 'OK' && data.userid) {
            this.g._sqzl.push({
                event: "CriteoUserIdSync",
                criteo_userid: data.userid
            });
        }
    }

    getMainCookie() {
        if(!this.createdCookie) {
            this.createdCookie = sqzlCommon.readCookie(this.constants.mainCookieName);
            if(!this.createdCookie) {
                if(!this.#sqzlTestMode) {
                    this.createdCookie = sqzlCommon.uniqid('sqzl');
                }
                else {
                    this.createdCookie = 'sqzl-test-cookie';
                }
                var cookieLifetime = 0;
                if(parseInt(sqzlCommon.getConfigItem('sqzlCookieLifetimeYears', 0)) > 0) {
                    cookieLifetime += parseInt(sqzlCommon.getConfigItem('sqzlCookieLifetimeYears')) * 365;
                }
                if(parseInt(sqzlCommon.getConfigItem('sqzlCookieLifetimeDays', 0)) > 0) {
                    cookieLifetime += parseInt(sqzlCommon.getConfigItem('sqzlCookieLifetimeDays'));
                }
                cookieLifetime = cookieLifetime > 0 ? cookieLifetime : 10957; //30 y
                sqzlCommon.createCookie(this.constants.mainCookieName, this.createdCookie, cookieLifetime);
            }
        }
        return this.createdCookie;
    }


    /**
     * @param {Object} data
     * @return {Object} data
     */
    truncateProductToMaximumAmount(data) {
        // See if too many products where added to the event
        var maximumProducts = 50;
        if(data.event === 'Purchase') {
            maximumProducts = 100;
        }

        if(
            data.hasOwnProperty('products') && typeof data.products === 'object' &&
            data.products.length > maximumProducts
        ) {
            console.warn('Squeezely event contains too many products, only the first ' + maximumProducts + ' products will be sent');
            console.info('The Squeezely Purchase event supports a maximum of 100 products, any other event a maximum of 50');

            data.products = data.products.slice(0, maximumProducts);

            if(
                data.hasOwnProperty('product_ids') && typeof data.product_ids === 'object' &&
                data.product_ids.length > maximumProducts
            ) {
                data.product_ids = data.product_ids.slice(0, maximumProducts);
            }
        }

        return data;
    }

    rewriteParametersLongToShort(data) {
        /*
            When updating this array please also update in Request.js
            arrays are the same for convenience and vars are swapped around
        */
        var rewriteParameters = {
            event: 'e',
        };

        for(var originalParameter in rewriteParameters) {
            if(data.hasOwnProperty(originalParameter)) {
                var newParameter = rewriteParameters[originalParameter];
                var originalValue = data[originalParameter];
                delete data[originalParameter];

                if(newParameter === 'e') {
                    // Push in front
                    data = Object.assign({[newParameter]: originalValue}, data);
                }
                else {
                    // Push in back (old behaviour)
                    data = Object.assign(data, {[newParameter]: originalValue});
                }
            }
        }

        return data;
    }

    /**
     * @param {Object} data
     * @param {Object} hceData
     */
    loadAws(data, hceData) {
        // AWS Tracker

        data = this.truncateProductToMaximumAmount(data);

        var rewriteData = Object.assign({}, data);

        if(hceData) {
            rewriteData.hce_data = hceData;
        }

        rewriteData = this.rewriteParametersLongToShort(rewriteData);

        if(data.hasOwnProperty('event') &&
            (data.event === 'ReloadPersonalization' || data.event === 'PageReload')) {
            this.triggerCallback(data);
            this.loadDataLayer(false);
        }
        else {
            var img = this.g.document.createElement("img");
            img.src = this.url + '?' + sqzlCommon.serialize(rewriteData);
            img.height = '1';
            img.width = '1';
            img.style.position = "fixed";
            img.style.bottom = "0px";
            img.style.width = '1px';
            img.style.height = '1px';
            img.alt = '';

            img.onload = function() {
                this.triggerCallback(data);
            }.bind(this);

            // img.onerror = function() {
            //     // catch error, sent health log
            // }.bind(this);

            sqzlCommon.appendElementToPage(img);
        }
    }

    triggerCallback(data) {
        // Already fired before this log_id, ignore
        if(data.hasOwnProperty('log_id') && this.eventCallbacksFired.hasOwnProperty(data.log_id)) return false;

        if(this.eventCallbacks.length > 0) {
            this.eventCallbacks.forEach(function(eventCallback) {
                if(eventCallback.hasOwnProperty('callbackFunction')) {
                    eventCallback.callbackFunction(data);
                    if(data.hasOwnProperty('log_id')) {
                        this.eventCallbacksFired[data.log_id] = true;
                    }
                }
            }.bind(this));
        }

        if(typeof data.callback !== 'undefined' && data.callback) {
            data.callback(data);
            if(data.hasOwnProperty('log_id')) {
                this.eventCallbacksFired[data.log_id] = true;
            }
        }
    }

    formatLogData(data) {
        if(sqzlCommon.isAnonymous()) {
            data = this.emptyPiiData(data);
        }

        return {
            originalData: sqzlCommon.serialize(data, false),
            isBot: this.isBot(),
            buildTime: sqzlCommon.getBuildTime()
        };
    }

    /**
     * rewrite facebook events so we understand them
     * @param {Object} data
     */
    parseFacebookEvent(data) {
        switch (data[0]) {
            case 'init':
                sqzlCommon.setConfigItem('sqzlFbPixelId', data[1]);
                return false;
            case 'track':
                data = Object.assign({"event": data[1], "raw_data": data[2], "frontend_event_id": data[3].eventID}, data[3]);
                break;
            case 'trackSingle':
            case 'trackSingleCustom':
                sqzlCommon.setConfigItem('sqzlFbPixelId', data[1]);
                data = Object.assign({"event": data[2], "raw_data": data[3], "frontend_event_id": data[4].eventID}, data[4]);
        }
        return data;
    }

    /**
     * @param {Object} data
     */
    loadFacebookPixel(data) {
        /**
         * @var {string} trackEvent
         */
        var trackEvent = data.event,
            sqzlFbPixelId = sqzlCommon.getConfigItem('sqzlFbPixelId');
        if(sqzlFbPixelId && !this.capiMerchant) {
            if(!this.g.fbq) {
                !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(this.g,
                document,'script','//connect.facebook.net/en_US/fbevents.js')
            }

            if(!this.fbPixelInited) {
                this.g.fbq('init', sqzlFbPixelId, { external_id: this.getMainCookie()});
                this.fbPixelInited = true;
            }

            var trackOptions = {
                timestamp: data.timestamp,
                user_agent: data.user_agent
            };
            data = this.parseCustomFields(data);
            //add other data fields
            for(var i in data) {
                if(data.hasOwnProperty(i) && !trackOptions.hasOwnProperty(i)) {
                    if(i !== 'email' && i !== 'email_hash' && i !== 'newsletter' && i !== 'userid' && i !== 'firstname' && i !== 'lastname' && i !== 'street' && i !== 'phone' && i !== 'postcode' && i !== 'consent' && i !== 'country' && i !== 'city' && i !== 'orderid' && i !== 'gender' && i !== 'birthdate' && i !== 'url') {
                        trackOptions[i] = data[i];
                    }
                }
            }

            if(
                // Don't add value field for these events, it'll trigger a no currency set warning in facebook + the console.
                [
                    'PersonalizationView',
                    'PersonalizationClick',
                    'PersonalizationClosed',
                    'Search'
                ].indexOf(trackEvent) === -1 &&
                typeof data.totalvalue !== 'undefined'
            ) {
                trackOptions.value = data.totalvalue;
            }
            //catalog events
            trackOptions.content_type = typeof data.content_type === 'undefined' ? 'product' : data.content_type;
            trackOptions.content_ids = [];
            if(
                typeof data.category_id !== 'undefined' &&
                (trackEvent === 'ViewCategory' || trackEvent === 'ViewContent')
            ) {
                //we need to rewrite to category_id for fb
                if(trackEvent === 'ViewCategory') {
                    trackOptions.category_id = data.category_id;
                }
                else if(trackEvent === 'ViewContent') {
                    trackOptions.content_category = data.category_id;
                }
            }

            if(typeof data.product_ids !== 'undefined') {
                trackOptions.content_ids = [].concat(data.product_ids);
            }
            //add parent ids if available
            if(typeof data.products !== 'undefined') {
                if(Array.isArray(data.products)) {
                    data.products.forEach(function(product) {
                        if(typeof product.parent_id !== 'undefined') {
                            trackOptions.content_ids.push(typeof product.parent_id === 'string' ? product.parent_id.trim() : product.parent_id);
                            trackOptions.content_type = ['product', 'product_group'];
                        }
                    });
                }
            }
            if(typeof data.audience_ids !== 'undefined' && data.audience_ids.length > 0) {
                trackOptions.audience_ids = '-' + data.audience_ids.join('-') + '-';
            }

            let trackType = 'trackSingleCustom';
            if(
                [
                    'AddPaymentInfo',
                    'AddToCart',
                    'AddToWishlist',
                    'CompleteRegistration',
                    'Contact',
                    'CustomizeProduct',
                    'Donate',
                    'InitiateCheckout',
                    'Lead',
                    'PageView',
                    'Purchase',
                    'Schedule',
                    'Search',
                    'StartTrial',
                    'SubmitApplication',
                    'Subscribe',
                    'ViewContent'
                ].indexOf(trackEvent) !== -1
            ) {
                trackType = 'trackSingle';
            }
            this.g.fbq(trackType, sqzlFbPixelId, trackEvent, trackOptions, {eventID: data.frontend_event_id});
        }
    }

    /**
     * @param {Object} data
     */
    loadFloodlight(data) {
        var DCMAdvertiser = sqzlCommon.getConfigItem('sqzlDCMAdvertiser'),
            floodlightVariableMap = sqzlCommon.getConfigItem('sqzlFloodlightVariableMap', {});
        if(DCMAdvertiser && floodlightVariableMap) {
            var queryString = ';src=' + DCMAdvertiser +';type=' +
                sqzlCommon.getConfigItem('sqzlFloodlightActivityType') +
                ';cat=' + sqzlCommon.getConfigItem('sqzlFloodlightActivityCat');
            if(typeof data.product_ids !== 'undefined') {
                data.content_ids = data.product_ids.join(','); // floodlight U-term is called content_ids
            }
            for(var i in data) {
                if(typeof floodlightVariableMap[i] !== 'undefined') {
                    queryString += ';' + floodlightVariableMap[i].toLowerCase() + '=' + encodeURIComponent(data[i]);
                }
            }

            var axel = Math.random()+"";
            var a = axel * 10000000000000000;

            var flDiv= this.g.document.createElement("div");

            sqzlCommon.appendElementToPage(flDiv);
            flDiv.setAttribute("id","DCLK_FLDiv" + a);
            flDiv.style.position="absolute";
            flDiv.style.top="0";
            flDiv.style.left="0";
            flDiv.style.width="1px";
            flDiv.style.height="1px";
            flDiv.style.display="none";
            flDiv.innerHTML='<iframe id="DCLK_FLIframe' + a + '" src="//' + DCMAdvertiser + '.fls.doubleclick.net/activityi' + queryString + ';ord=' + a + '?" width="1" height="1" frameborder="0"><\/iframe>';

            var floodlightSalesActivityType = sqzlCommon.getConfigItem('sqzlFloodlightSalesActivityType'),
                floodlightSalesActivityCat = sqzlCommon.getConfigItem('sqzlFloodlightSalesActivityCat');
            if(
                typeof data.event !== 'undefined' && data.event === 'Purchase' &&
                typeof data.orderid !== 'undefined' && data.orderid &&
                floodlightSalesActivityType && floodlightSalesActivityCat
            ) {
                var qty = typeof data.products !== 'undefined' && data.products.length ? data.products.length : 1;
                var totalvalue = data.totalvalue !== 'undefined' ? data.totalvalue : '';
                queryString = ';src=' + DCMAdvertiser +';type=' + floodlightSalesActivityType + ';cat=' + floodlightSalesActivityCat + ';qty=' + qty + ';cost=' + totalvalue;
                for(var j in data) {
                    if(typeof floodlightVariableMap[j] !== 'undefined') {
                        queryString += ';' + floodlightVariableMap[j].toLowerCase() + '=' + encodeURIComponent(data[j]);
                    }
                }

                var flDiv2= this.g.document.createElement("div");
                sqzlCommon.appendElementToPage(flDiv2);
                flDiv2.setAttribute("id","DCLK_FLDiv2" + a);
                flDiv2.style.position="absolute";
                flDiv2.style.top="0";
                flDiv2.style.left="0";
                flDiv2.style.width="1px";
                flDiv2.style.height="1px";
                flDiv2.style.display="none";
                flDiv2.innerHTML='<iframe id="DCLK_FLIframe2' + a + '" src="https://' + DCMAdvertiser + '.fls.doubleclick.net/activityi' + queryString + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + data.orderid + '?" width="1" height="1" frameborder="0"></iframe>';
            }
        }
    }

    loadGoogleGtag(data) {
        let handleGoogleTagCalled = false;
        let trackEvent = data.event,
            trackOptions = {
                ecomm_event: trackEvent
            },
            // we track these options:
            trackOptionKeys = [
                'utm_campaign',
                'utm_source',
                'sqzl_campaign',
                'sqzl_source',
                'keyword',
                'currency',
                'totalvalue',
                'audience_ids'
            ],
            action = '',
            item = '';

            if(!this.#sqzlTestMode) {
                trackOptions.ecomm_timestamp = data.timestamp;
            }

            for(var i = 0; i < trackOptionKeys.length; i++) {
                if(data.hasOwnProperty(trackOptionKeys[i])) {
                    var value = data[trackOptionKeys[i]];
                    if(
                        trackOptionKeys[i] === 'audience_ids' &&
                        typeof value === 'object'
                    ) {
                        trackOptions['ecomm_' + trackOptionKeys[i]] = '-' + value.join('-') + '-';
                    }
                    else {
                        trackOptions['ecomm_' + trackOptionKeys[i]] = value;
                    }
                }
            }

            for(var property in data) {
                if(data.hasOwnProperty(property) && property.match(/^custom_/)) {
                    trackOptions[property] = data[property];
                }
            }

            switch(trackEvent) {
                case 'ViewContent':
                    trackOptions.ecomm_pagetype = 'product';
                    action = 'view_item';
                    break;
                case 'ViewCategory':
                    trackOptions.ecomm_pagetype = 'category';
                    if(typeof data.category_id !== 'undefined') {
                        trackOptions.ecomm_category_id = data.category_id;
                    }
                    action = 'view_item_list';
                    break;
                case 'AddToCart':
                    action = 'add_to_cart';
                    break;
                case 'Search':
                    action = 'search';
                    if(typeof data.keyword !== 'undefined') {
                        trackOptions.search_term = data.keyword;
                    }
                    break;
                case 'Lead':
                    action = 'generate_lead';
                    break;
                case 'CompleteRegistration':
                    action = 'sign_up';
                    break;
                case 'PrePurchase':
                    action = 'begin_checkout';
                    break;
                case 'Purchase':
                    action = 'purchase';
                    break;
                case 'PageView':
                    action = 'pageview';
                    break;
                default:
                    action = typeof trackEvent !== 'undefined' ? trackEvent : '';
                    break;
            }

            if(typeof data.product_ids !== 'undefined') {
                trackOptions.ecomm_prodid = data.product_ids[0];
                trackOptions.ecomm_prodids = '-' + data.product_ids.join('-') + '-';
            }

            if(typeof data.products !== 'undefined') {
                trackOptions.items = [];
                for(var i = 0; i < data.products.length; i++) {
                    item = {
                        id: data.products[i].id,
                        price: data.products[i].price
                    };
                    if(data.products[i].hasOwnProperty('name')) {
                        item.name = data.products[i].name;
                    }
                    if(data.products[i].hasOwnProperty('category_id')) {
                        item.category = data.products[i].category_id;
                    }
                    else if(typeof data.category_id !== 'undefined') {
                        item.category = data.category_id;
                    }
                    trackOptions.items.push(item);
                }
            }

            if(action.length === 0) action = 'pageview'; // fallback default to pageview, to avoid empty eventName

        if(this.googleConversionId) {
            var sqzlGoogleOptions = {
                google_conversion_id: this.googleConversionId,
                google_custom_params: trackOptions,
                google_remarketing_only: true,
                send_to: 'AW-' + this.googleConversionId
            };
            if(typeof data.orderid !== 'undefined') {
                // Avoid duplicate tracking of conversions
                sqzlGoogleOptions.google_conversion_order_id = data.orderid;
            }

            if(typeof data.currency !== 'undefined' && typeof data.totalvalue !== 'undefined') {
                sqzlGoogleOptions.google_conversion_value = data.totalvalue;
                sqzlGoogleOptions.google_conversion_currency = data.currency;
            }

            if(this.googleConversionLabel && trackEvent === 'Purchase') {
                sqzlGoogleOptions.google_conversion_label = this.googleConversionLabel;
            }

            if(trackEvent === 'Purchase') {
                sqzlGoogleOptions.google_remarketing_only = false;
            }

            // merge ecomm_* track options to sqzlGoogleOptions
            for(var attrname in trackOptions) {
                if(attrname.match(/^ecomm_/) || attrname.match(/^custom_/)) {
                    sqzlGoogleOptions[attrname] = trackOptions[attrname];
                }
            }

            action = 'sqzly_' + action;

            handleGoogleTagCalled = true;
            this.handleGoogleGtag('event', action, sqzlGoogleOptions, this.gtag, true);

            if(trackEvent === 'Purchase' && this.googleConversionLabel) {
                // Should also fire google adwords conversion event
                if(typeof data.totalvalue === 'string') {
                    data.totalvalue = parseFloat(data.totalvalue);
                }

                var sqzlGoogleConversionOptions = {
                    send_to: 'AW-' + this.googleConversionId + '/' + this.googleConversionLabel,
                    value: data.totalvalue,
                    currency: data.currency
                };

                if(typeof data.orderid !== 'undefined') {
                    // Avoid duplicate tracking of conversions
                    sqzlGoogleConversionOptions.transaction_id = data.orderid;
                }

                handleGoogleTagCalled = true;
                this.handleGoogleGtag('event', 'conversion', sqzlGoogleConversionOptions, this.gtag, true);
            }
        }

        //GA4
        let ga4Events = this.ga4EnabledEvents() ;
        if(ga4Events.length > 0 && ga4Events.indexOf(trackEvent) !== -1) {
                let items = [];
                if(typeof data.product_ids !== 'undefined') {
                    for (var i = 0; i < data.product_ids.length; i++) {
                        items.push({item_id: data.product_ids[i].id, item_name: data.product_ids[i].id})
                    }
                }

                if(typeof data.products !== 'undefined') {
                    items = [];
                    for(var i = 0; i < data.products.length; i++) {
                        let item = {
                            item_id: data.products[i].id,
                            item_name: data.products[i].hasOwnProperty('name') ? data.products[i].item_name : data.products[i].id //required
                        };
                        if(data.products[i].hasOwnProperty('price')) {
                            item.price = data.products[i].price;
                        }
                        if(data.products[i].hasOwnProperty('quantity')) {
                            item.quantity = data.products[i].quantity;
                        }
                        if(data.products[i].hasOwnProperty('category_id')) {
                            item.item_category = data.products[i].category_id;
                        }
                        else if(typeof data.category_id !== 'undefined') {
                            item.item_category = data.category_id;
                        }
                        items.push(item);
                    }
                }
                let options = {
                    items: items
                }
                if(
                    [
                        'ViewContent',
                        'AddToCart',
                        'RemoveFromCart',
                        'InitiateCheckout',
                        'Purchase'
                    ].indexOf(trackEvent) > -1) {
                    options.value = data.totalvalue;
                    options.currency = data.currency;
                }
                if(trackEvent === 'ViewCategory') {
                    if(typeof data.category_id !== 'undefined') {
                        options.item_list_id = data.category_id;
                    }
                }
                if(trackEvent === 'SqueezelyAudience') {
                    var audienceIdsConcat = "-";

                    data.audience_ids.forEach(function(key) {
                        if((audienceIdsConcat + key.toString() + "-").length > 500) {
                            options.audience_ids = audienceIdsConcat;
                            audienceIdsConcat = "-";
                        }
                        else {
                            audienceIdsConcat += key.toString() + "-";
                        }
                    });

                    if(audienceIdsConcat.length > 1) {
                        options.audience_ids = audienceIdsConcat;
                    }
                }
                if(trackEvent === 'Purchase') {
                    options.transaction_id = data.orderid;
                }
                if(trackEvent === 'PersonalizationView' || trackEvent === 'PersonalizationClick') {
                    options.personalization_id = data.personalization_id;
                    options.personalization_variant_id = data.personalization_variant_id;
                    options.control_variant = data.orderid;
                    if(this.ga4PassPersonalizationNames()) {
                        options.personalization_name = sqzlCommon.getPersonalizationName(options.personalization_id);
                        options.variant_name = sqzlCommon.getVariantName(options.personalization_variant_id);
                    }
                }
                let eventNames = {
                    ViewContent: 'view_item',
                    ViewCategory: 'view_item_list',
                    AddToCart: 'add_to_cart',
                    RemoveFromCart: 'remove_from_cart',
                    InitiateCheckout: 'begin_checkout',
                    Purchase: 'purchase',
                    PersonalizationView: 'PersonalizationView',
                    PersonalizationClick: 'PersonalizationClick',
                    SqueezelyAudience: 'SqueezelyAudience',
                }
                handleGoogleTagCalled = true;
                this.handleGoogleGtag('event', eventNames[trackEvent], options, this.gtag, false);
            }

        return handleGoogleTagCalled;
    }

    handleGoogleGtag(eventType, eventName, event, callback, requireConversionId) {
        if(requireConversionId && !this.googleConversionId) {
            if(sqzlCommon.isWarningEnabled()) {
                console.warn('sqzly: No googleConversionId set');
            }
            return;
        }

        if(typeof event !== 'object' || typeof callback !== 'function') {
            if(sqzlCommon.getDebugLevel()) {
                console.error('sqzly: Invalid event or callback');
            }
            return;
        }

        // gtag is used for conversion tracking and GA4 tracking. GA4 does not require a conversion id.
        let gtaghash = requireConversionId ? 'AW-' + this.googleConversionId : this.settings.ga.ua;
        if(this.state.gtagLoaded.hasOwnProperty(gtaghash) && this.state.gtagLoaded[gtaghash] === false) {
           // Debounce inserting script tags when one is already inserted, still loading.
            setTimeout(function() {
                this.handleGoogleGtag(eventType, eventName, event, callback, requireConversionId);
            }.bind(this), 50);
            return;
        }

        if(this.state.gtagLoaded.hasOwnProperty(gtaghash) && this.state.gtagLoaded[gtaghash]) {
            callback.apply(this, [eventType, eventName, event]);
            return;
        }

        this.state.gtagLoaded[gtaghash] = false;

        let s = this.g.document.createElement('script');
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtaghash;
        s.async = true;
        s.onreadystatechange = s.onload = function() {
            if((!s.readyState || /loaded|complete/.test(s.readyState))) {
                this.gtag('js', new Date());
                this.gtag('config', gtaghash, {
                    conversion_linker: sqzlCommon.hasMarketingConsent(),
                    send_page_view: false
                });

                this.state.gtagLoaded[gtaghash] = true;

                callback.apply(this, [eventType, eventName, event]);
            }
        }.bind(this);
        sqzlCommon.appendElementToPage(s);
    }

    /**
     * @returns {boolean}
     */
    gptLoaded() {
        return this.state.gptLoaded.initialized;
    }

    forwardToGooglePublisherTag(data) {
        var trackEvent = data.event,
            sqzlGooglePublisherTagCommand = false;

        switch(trackEvent) {
            case 'SqueezelyAudience':
                if(
                    !data.hasOwnProperty('audience_ids') ||
                    typeof data.audience_ids !== 'object' ||
                    data.audience_ids.length === 0
                ) {
                    return false;
                }

                // data.audience_ids contains integers, all values are treated as strings by ad manager
                // @see https://support.google.com/admanager/answer/177381?hl=en
                // So make sure we set them as strings, just to be sure
                sqzlGooglePublisherTagCommand = function() {
                    // Add key-value pair to target on
                    let sqzlAudienceIds = [];
                    for(let i = 0; i < data.audience_ids.length; i++) {
                        sqzlAudienceIds.push('' + data.audience_ids[i]);
                    }

                    // Page level targeting, tag applies to all slots
                    this.g.googletag.pubads().setTargeting('sqzlAudienceId', sqzlAudienceIds);
                }.bind(this);
                break;
            default:
                // For now only handle SqueezelyAudience events, we might add more in the future
                return false;
        }

        this.handleGooglePublisherTag(sqzlGooglePublisherTagCommand, this.gpt.bind(this));

        return true;
    }

    handleGooglePublisherTag(command, callback) {
        if(typeof command !== 'function' || typeof callback !== 'function') {
            if(sqzlCommon.getDebugLevel()) {
                console.error('sqzly: Invalid command or callback');
            }
            return;
        }

        if(this.gptLoaded() === false) {
            if(!this.g.hasOwnProperty('googletag')) {
                this.g.googletag = this.g.googletag || {cmd: []};
            }
            this.state.gptLoaded.initialized = true;
        }

        if(this.gptLoaded()) {
            // Queue the cmd
            callback(command);
        }
    }

    cookieSync() {
        if(sqzlCommon.getConfigItem('sqzlPlatform161Enabled')) {
            let syncUrl = 'https://ads.creative-serving.com/cm?redir=' + this.url + '?newtracker=true&merchantid=' +
                sqzlCommon.getConfigItem('sqzlAccount') + '&e=CookieSync161&ab=0&cookie=' + this.getMainCookie() + '&value=${UUID}';
            if(sqzlCommon.getDataCenter()) {
                syncUrl = syncUrl + '&datacenter=' + sqzlCommon.getDataCenter();
            }
            let img = this.g.document.createElement("img");
            img.src = syncUrl;
            img.height = '1';
            img.width = '1';
            img.style.position = "fixed";
            img.style.bottom = "0px";
            img.style.width = '1px';
            img.style.height = '1px';
            img.alt = '';

            sqzlCommon.appendElementToPage(img);
        }
    }

    loadEventForward(data) {
        if(
            typeof sqzlCommon.getConfigItem('eventForwarding') === 'object'
        ) {
            var eventForwarding = sqzlCommon.getConfigItem('eventForwarding');
            for(var forwardType in eventForwarding) {
                if(eventForwarding.hasOwnProperty(forwardType)) {
                    try {
                        switch(forwardType) {
                            case 'GA':
                                // Google analytics event forwarding
                                if(!sqzlCommon.hasAnalyticsConsent()) {
                                    // We don't have consent
                                    continue;
                                }
                                this.forwardToGa(data);
                                break;
                            case 'GPT':
                                if(!sqzlCommon.hasMarketingConsent()) {
                                    // We don't have consent
                                    continue;
                                }

                                this.forwardToGooglePublisherTag(data);
                                break;
                            default:
                                console.error('sqzly: forward type ' + forwardType + ' undefined');
                                break;
                        }
                    }
                    catch(e) {
                        sqzlCommon.sqzlException(e, data);
                        let errorEvent = '';
                        if(data.hasOwnProperty('event')) {
                            errorEvent += ' ' + data.event;
                        }

                        console.error('sqzly: failed to ' + forwardType + ' forward event' + errorEvent);
                    }
                }
            }
        }
    }

    initializeGa(data) {
        var eventForwarding = sqzlCommon.getConfigItem('eventForwarding');
        if(
            this.state.gaLoaded.initialized === false &&
            eventForwarding !== null &&
            typeof eventForwarding === 'object' &&
            Object.keys(eventForwarding).length > 0 &&
            eventForwarding.hasOwnProperty('GA') &&
            typeof eventForwarding['GA'].events === 'object' &&
            Object.keys(eventForwarding['GA'].events).length > 0
        ) {
            // Not initialized, have proper config
            if(sqzlCommon.isDebugEnabled()) {
                console.debug('sqzly: Valid GA event forwarding configuration found, initializing');
            }

            this.state.gaLoaded.initialized = true;

            var gaSettings = eventForwarding['GA'].settings;

            this.settings.ga.ua = gaSettings.ua;
            this.settings.ga.events = eventForwarding['GA'].events;
            this.settings.ga4.events = sqzlCommon.getConfigItem('ga4Events');
            this.settings.ga4.passPersonalizationNames = sqzlCommon.getConfigItem('ga4PassPersonalizationNames');

            if(
                this.g.hasOwnProperty('GoogleAnalyticsObject') &&
                typeof this.g.GoogleAnalyticsObject === 'string' &&
                this.g.GoogleAnalyticsObject !== ''
            ) {
                // We have a custom GA object name
                this.settings.ga.gaObject = this.g.GoogleAnalyticsObject;
            }

            if(
                !this.g.hasOwnProperty(this.settings.ga.gaObject) ||
                typeof this.g[this.settings.ga.gaObject] !== 'function'
            ) {
                // Google analytics has not been loaded yet, do so
                this.requireGaObject();
            }

            return false;
            // this.state.gaLoaded.enabled = true;
            //
            // if(sqzlCommon.isDebugEnabled()) {
            //     console.debug('sqzly: Pushing GA tracker initializer into GA queue');
            // }
            //
            // // Check if UA has been registered, as soon as the queue is being handled
            // this.g[this.settings.ga.gaObject](function() {
            //     if(sqzlCommon.isDebugEnabled()) {
            //         console.debug('sqzly: Executing GA tracker initializer');
            //     }
            //
            //     // Don't re-use the tracker, so we can always enable the enhanced ecommerce module
            //     // var createTracker = true,
            //         // loadedTrackers = this.g[this.settings.ga.gaObject].getAll();
            //
            //     // if(
            //     //     typeof loadedTrackers === 'object' &&
            //     //     loadedTrackers.length > 0
            //     // ) {
            //     //     for(var i = 0; i < loadedTrackers.length; i++) {
            //     //         if(
            //     //             loadedTrackers.hasOwnProperty(i) &&
            //     //             typeof loadedTrackers[i] === 'object' && loadedTrackers[i].hasOwnProperty('b') &&
            //     //             typeof loadedTrackers[i].b === 'object' && loadedTrackers[i].b.hasOwnProperty('data') &&
            //     //             typeof loadedTrackers[i].b.data === 'object' && loadedTrackers[i].b.data.hasOwnProperty('values') &&
            //     //             typeof loadedTrackers[i].b.data.values === 'object' && loadedTrackers[i].b.data.values.hasOwnProperty(':trackingId') &&
            //     //             loadedTrackers[i].b.data.values[':trackingId'] === this.settings.ga.ua
            //     //         ) {
            //     //             // A tracker with this UA is already created/available
            //     //             this.settings.ga.trackerName = loadedTrackers[i].b.data.values[':name'];
            //     //             createTracker = false;
            //     //             break;
            //     //         }
            //     //     }
            //     // }
            //
            //     // if(createTracker) {
            //     //     this.g[this.settings.ga.gaObject]('create', this.settings.ga.ua, 'auto', 'sqzlGaTracker');
            //     //     this.settings.ga.trackerName = 'sqzlGaTracker';
            //         this.g[this.settings.ga.gaObject]('create', this.settings.ga.ua, 'auto', this.settings.ga.trackerName);
            //         // this.settings.ga.trackerName = 'sqzlGaTracker';
            //         this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.require', 'ec');
            //     // }
            //
            //     // Queue the first event when GA has been initialized
            //     this.g[this.settings.ga.gaObject](function() {
            //         this.forwardToGa(data);
            //     }.bind(this));
            // }.bind(this));
        }
        else if(sqzlCommon.getDebugLevel()) {
            console.warn('sqzly: No valid GA event forwarding configuration found');
        }
    }

    requireGaObject() {
        return false; // This is <= GA3
    }

    /**
     * @returns {boolean}
     */
    gaLoaded() {
        return this.state.gaLoaded.initialized;
    }

    /**
     * @returns {boolean}
     */
    gaEnabled() {
        return false; // GA3 code
        // return this.state.gaLoaded.enabled;
    }

    /**
     * @returns {object}
     */
    gaEnabledEvents() {
        return {}; // GA3 code
        // if(this.settings.ga.hasOwnProperty('events')) {
        //     return this.settings.ga.events;
        // }
        //
        // return {};
    }

    /**
     * @returns []
     */
    ga4EnabledEvents() {
        if(
            this.settings.ga4.hasOwnProperty('events') &&
            this.settings.ga4.events !== null
        ) {
            return Object.values(this.settings.ga4.events);
        }
        return [];
    }
    /**
     * @returns {boolean}
     */
    ga4PassPersonalizationNames() {
        return this.settings.ga4.hasOwnProperty('passPersonalizationNames') ? this.settings.ga4.passPersonalizationNames : false;
    }

    /**
     * @param {object} data
     *
     * @returns {boolean}
     */
    forwardToGa(data) {
        var enabledEvents = {};

        /**
         * This is old GA3 code, but we can't disable it
         * Because in initializeGa() things are done for GA4 as well
         * So this needs refactoring and splitting up
         *
         * For now gaEnabled() returns false and gaEnabledEvents() returns an empty object to avoid GA3 events being triggered
         */
        if(this.gaLoaded() === false) {
            this.initializeGa(data);
            return false;
        }
        enabledEvents = this.gaEnabledEvents();

        if(
            this.gaEnabled() &&
            enabledEvents.hasOwnProperty(data.event) && enabledEvents[data.event] === true
        ) {
            if(sqzlCommon.isDebugEnabled()) {
                console.debug('sqzly: Forwarding event to GA', {
                    event: data
                });
            }

            // We have a valid config, and the initialization has been queued or already executed
            this.g[this.settings.ga.gaObject](function() {
                // Add this command to the queue
                // The double callback makes sure that GA has been loaded
                // And this.settings.ga.trackerName is set, as the queue is handled in order
                if(
                    data.hasOwnProperty('currency') &&
                    this.getConstants().gaSupportedCurrencies.hasOwnProperty(data.currency)
                ) {
                    // Set global currency
                    this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.set', 'currencyCode', data.currency);
                }
                // Format some known events into GA format
                switch(data.event) {
                    case 'PageView':
                        // @note This will not filter out any variables in the URL to group by page type..
                        // Example /user/1234/profile will be different pv for every user
                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'pageview',
                            page: this.g.location.pathname,
                            nonInteraction: true
                        });
                        //also send as event
                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            eventLabel: 'PageView',
                            nonInteraction: true
                        });
                        break;
                    case 'ViewCategory':
                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            eventLabel: data.hasOwnProperty('category_id') ? data.category_id : '',
                            nonInteraction: true
                        });
                        break;
                    case 'PersonalizationView':
                    case 'PersonalizationClick':
                        if(!data.hasOwnProperty('personalization_id') || !data.hasOwnProperty('personalization_variant_id') || !data.personalization_id || !data.personalization_variant_id ) {
                            return false;
                        }
                        if(data.hasOwnProperty('products')) {
                            if(Array.isArray(data.products) && data.products.length > 0) {
                                var position = 1;
                                data.products.forEach(function(product) {
                                    if(!product.hasOwnProperty('id')) {
                                        return;
                                    }

                                    var productProperties = {
                                        id: product.id
                                    };

                                    if(product.hasOwnProperty('name')) {
                                        productProperties.name = product.name;
                                    }

                                    if(product.hasOwnProperty('price')) {
                                        productProperties.price = product.price;
                                    }

                                    productProperties.position = position;

                                    this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.ec:addProduct', productProperties);
                                    position++;
                                }.bind(this));
                            }
                        }

                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            eventLabel: 'Personalization ' + data.personalization_id + ', variant ' + data.personalization_variant_id,
                            nonInteraction: true
                        });
                        break;
                    case 'ViewContent':
                        if(data.hasOwnProperty('products')) {
                            if(Array.isArray(data.products) && data.products.length > 0) {
                                var position = 1;
                                data.products.forEach(function(product) {
                                    if(!product.hasOwnProperty('id')) {
                                        return;
                                    }

                                    var productProperties = {
                                        id: product.id
                                    };

                                    if(product.hasOwnProperty('name')) {
                                        productProperties.name = product.name;
                                    }

                                    if(product.hasOwnProperty('price')) {
                                        productProperties.price = product.price;
                                    }

                                    productProperties.position = position;

                                    this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.ec:addProduct', productProperties);
                                    position++;
                                }.bind(this));
                            }

                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.ec:setAction', 'detail');
                        }

                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            nonInteraction: true
                        });
                        break;
                    case 'Purchase':
                        if(data.hasOwnProperty('products')) {
                            var totalValue = 0;
                            if(Array.isArray(data.products) && data.products.length > 0) {
                                data.products.forEach(function(product) {
                                    if(!product.hasOwnProperty('id')) {
                                        return;
                                    }

                                    var quantity = 1,
                                        productProperties = {
                                            id: product.id
                                        };

                                    if(product.hasOwnProperty('name')) {
                                        productProperties.name = product.name;
                                    }

                                    if(product.hasOwnProperty('quantity') && product.quantity > 0) {
                                        quantity = product.quantity;
                                    }
                                    productProperties.quantity = quantity;

                                    if(product.hasOwnProperty('price')) {
                                        totalValue += product.price * quantity;
                                        productProperties.price = product.price;
                                    }

                                    this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.ec:addProduct', productProperties);
                                }.bind(this));
                            }

                            var purchaseProperties = {
                                id: data.orderid
                            };

                            if(totalValue > 0) {
                                purchaseProperties.revenue = totalValue;
                            }

                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.ec:setAction', 'purchase', purchaseProperties);
                        }

                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            nonInteraction: true
                        });
                        break;
                    case 'Search':
                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                            hitType: 'event',
                            eventCategory: this.settings.ga.categoryName,
                            eventAction: data.event,
                            eventLabel: data.hasOwnProperty('keyword') ? data.keyword : '',
                            nonInteraction: true
                        });
                        break;
                    case 'EmailOptIn':
                        if(data.hasOwnProperty('newsletter')) {
                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                                hitType: 'event',
                                eventCategory: this.settings.ga.categoryName,
                                eventAction: data.newsletter === 'yes' ? 'Subscribe' : 'Unsubscribe',
                                eventLabel: 'Newsletter',
                                nonInteraction: true
                            });
                        }
                        if(data.hasOwnProperty('marketing')) {
                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                                hitType: 'event',
                                eventCategory: this.settings.ga.categoryName,
                                eventAction: data.marketing === 'yes' ? 'Subscribe' : 'Unsubscribe',
                                eventLabel: 'Marketingletter',
                                nonInteraction: true
                            });
                        }
                        if(data.hasOwnProperty('service')) {
                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                                hitType: 'event',
                                eventCategory: this.settings.ga.categoryName,
                                eventAction: data.service === 'yes' ? 'Subscribe' : 'Unsubscribe',
                                eventLabel: 'Serviceletter',
                                nonInteraction: true
                            });
                        }
                        break;
                    case 'SqueezelyAudience':
                        var labels = [];
                        var label = "-";

                        data.audience_ids.forEach(function(key) {
                            if ((label + key.toString() + "-").length > 500) {
                                labels.push(label);
                                label = "-";
                            } else {
                                label += key.toString() + "-";
                            }
                        });

                        if(label.length > 1) {
                            labels.push(label);
                        }

                        labels.forEach(function(key)  {
                            this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', {
                                hitType: 'event',
                                eventCategory: this.settings.ga.categoryName,
                                eventAction: data.event,
                                eventLabel: key,
                                nonInteraction: true
                            });
                        }.bind(this));
                        break;
                    default:
                        var eventProperties = {
                            // The type of hit. Must be one of 'pageview', 'screenview', 'event', 'transaction', 'item', 'social', 'exception', 'timing'.
                            hitType: 'event',
                            // String, required
                            eventCategory: this.settings.ga.categoryName,
                            // String, required
                            eventAction: data.event
                            // Text, optional
                            // eventLabel: 'Fall Campaign'
                            // Integer, optional
                            // eventValue: 1337
                        };

                        eventProperties.nonInteraction = true;

                        if(data.hasOwnProperty('value')) {
                            eventProperties.eventLabel = data.value;
                        }

                        this.g[this.settings.ga.gaObject](this.settings.ga.trackerName + '.send', eventProperties);
                        break;
                }
            }.bind(this));
        }
        else {
            return false;
        }

        return true;
    }

    getURLParameter(name) {
        if(typeof name === 'string') {
            return (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, '']) [1].replace(/\+/g, '%20') || null;
        }

        return null;
    }

    /**
     * @returns {string | boolean}
     */
    getUserAgent() {
        return navigator.userAgent || navigator.vendor || this.g.opera;
    }

    getPlatform(platform) {
        if(typeof platform !== 'undefined') {
            return platform;
        }

        if(this.getUserAgent()) {
            if(this.getUserAgent().toLowerCase().indexOf("windows") >= 0 ) {
                return "windows";
            }
            else if(this.getUserAgent().toLowerCase().indexOf("android") >= 0) {
                return "android";
            }
            else if(this.getUserAgent().toLowerCase().indexOf("iphone") >= 0) {
                return "ios";
            }
            else if(this.getUserAgent().toLowerCase().indexOf("mac") >= 0) {
                return "mac";
            }
            else if(this.getUserAgent().toLowerCase().indexOf("x11") >= 0) {
                return "unix";
            }
        }

        return '';
    }

    /**
     * @returns {boolean|null}
     */
    isBot(userAgent) {
        if(typeof userAgent === 'undefined' || !userAgent) {
            userAgent = this.getUserAgent();
        }

        if(
            userAgent &&
            typeof sqzlCommon.mobileDetect !== 'undefined'
        ) {
            var md = new sqzlCommon.mobileDetect(userAgent);
            if(typeof md.isBot === 'function') {
                return md.isBot();
            }
        }

        return null;
    }

    handleEvent = function(bt) {
        /**
         * @param {Object} data
         */
        function handleEvent(data) {
            if(typeof data !== 'object' || typeof !data.hasOwnProperty('event') === 'undefined') {
                console.error('sqzly: Invalid sqzly event');
                return;
            }

            var eventName = data.event.toLowerCase();
            if(this.hasOwnProperty(eventName) && typeof this[eventName] === 'function') {
                try {
                    if(sqzlCommon.isDebugEnabled()) {
                        console.debug('sqzly: Handling event (' + eventName + ')', data);
                    }

                    this[eventName].apply(this, [data]);
                }
                catch(e) {
                    console.error('sqzly error', e);
                }
            }
            else {
                console.error('sqzly: Invalid event handler: ' + data.event);
            }
        }

        /**
         * @callback
         * @param {Object} data
         */
        function consent(data) {
            if(typeof data.status !== 'undefined' && (data.status === 'grant' || data.status === 'revoke')) {
                if(typeof data.permissions === 'undefined' || typeof data.permissions !== 'object') {
                    // All permissions
                    if(data.status === 'revoke') {
                        if(sqzlCommon.isDebugEnabled()) {
                            console.info('sqzly: Revoking all permissions');
                        }
                        bt.revokeConsent(
                            [],
                            data.hasOwnProperty('user_interaction') && typeof data.user_interaction === 'boolean' && data.user_interaction === true
                        );
                    }
                    else {
                        if(sqzlCommon.isDebugEnabled()) {
                            console.log('sqzly: Granting all permissions');
                        }
                        bt.grantConsent();

                        bt.loadDataLayerEvents();
                    }
                }
                else {
                    if(data.status === 'revoke') {
                        if(sqzlCommon.isDebugEnabled()) {
                            console.info('sqzly: Revoking permissions', data.permissions);
                        }
                        bt.revokeConsent(
                            data.permissions,
                            data.hasOwnProperty('user_interaction') && typeof data.user_interaction === 'boolean' && data.user_interaction === true
                        );
                    }
                    else {
                        if(sqzlCommon.isDebugEnabled()) {
                            console.info('sqzly: Granting permissions', data.permissions);
                        }
                        bt.grantConsent(data.permissions);

                        if(
                            data.permissions.indexOf('analytics') > -1
                        ) {
                            bt.loadDataLayerEvents();
                        }
                    }
                }
            }
            else {
                console.error('sqzly: Unknown value for consent (possible values: grant, revoke)');
            }
        }

        return {
            handleEvent: handleEvent,
            consent: consent
        };
    }(this);


    smartTracking(ecommerce) {
        // Old style - https://developers.google.com/tag-manager/enhanced-ecommerce
        // New style - https://developers.google.com/tag-manager/ecommerce-appweb
        var ecommerceEvent = null;
        if(typeof ecommerce === 'undefined' || ecommerce === null) return false;
        if(typeof ecommerce.event !== 'undefined') ecommerceEvent = ecommerce.event;

        if(typeof ecommerce.ecommerce !== 'undefined') ecommerce = ecommerce.ecommerce;
        if(ecommerce === null) return false;
        if(typeof ecommerce.event !== 'undefined') ecommerceEvent = ecommerce.event;

        var products = [];
        var eventData = {};
        var ecommerceProducts = null;

        // New style
        if(typeof ecommerce.items !== 'undefined') {
            ecommerceProducts = ecommerce.items;
        }

        if(typeof ecommerce.add !== 'undefined' || ecommerceEvent === 'add_to_cart' || ecommerceEvent === 'addToCart') { // Add to cart
            products = [];

            // Old style
            if(typeof ecommerce.add !== 'undefined') {
                if(typeof ecommerce.add.products !== 'undefined') {
                    ecommerceProducts = ecommerce.add.products;
                }

                if(typeof ecommerce.add.product !== 'undefined') {
                    products.push(this.sanitizeEcommerceProduct(ecommerce.add.product));
                }
            }

            if (ecommerceProducts !== null) {
                for (var i = 0; i < ecommerceProducts.length; i++) {
                    products.push(this.sanitizeEcommerceProduct(ecommerceProducts[i]));
                }
            }

            var eventData = {
                event: "AddToCart",
                products: products
            };

            // Old style
            if(typeof ecommerce.currencyCode !== 'undefined') {
                eventData.currency = ecommerce.currencyData;
            }

            this.g.sqzl.q.push([eventData]);
        }

        if(typeof ecommerce.remove !== 'undefined' || ecommerceEvent === 'remove_from_cart' || ecommerceEvent === 'removeFromCart') { // Remove from cart
            products = [];

            // Old style
            if(typeof ecommerce.remove !== 'undefined') {
                if(typeof ecommerce.remove.products !== 'undefined') {
                    ecommerceProducts = ecommerce.remove.products;
                }

                if(typeof ecommerce.remove.product !== 'undefined') {
                    products.push(this.sanitizeEcommerceProduct(ecommerce.remove.product));
                }
            }

            if (ecommerceProducts !== null) {
                for (var i = 0; i < ecommerceProducts.length; i++) {
                    products.push(this.sanitizeEcommerceProduct(ecommerceProducts[i]));
                }
            }

            var eventData = {
                event: "RemoveFromCart",
                products: products
            };

            // Old style
            if(typeof ecommerce.currencyCode !== 'undefined') {
                eventData.currency = ecommerce.currencyData;
            }

            this.g.sqzl.q.push([eventData]);
        }

        if(typeof ecommerce.detail !== 'undefined' || ecommerceEvent === 'view_item') { // Views of Product Details
            products = [];

            // Old style
            if (typeof ecommerce.detail !== 'undefined') {
                if (typeof ecommerce.detail.products !== 'undefined') {
                    ecommerceProducts = ecommerce.detail.products;
                }

                if(typeof ecommerce.detail.product !== 'undefined') {
                    products.push(this.sanitizeEcommerceProduct(ecommerce.detail.product));
                }
            }

            if (ecommerceProducts !== null) {
                for (var i = 0; i < ecommerceProducts.length; i++) {
                    products.push(this.sanitizeEcommerceProduct(ecommerceProducts[i]));
                }
            }

            this.g.sqzl.q.push([{
                event: "ViewContent",
                products: products
            }]);
        }

        if(typeof ecommerce.checkout !== 'undefined' || ecommerceEvent === 'begin_checkout' || ecommerceEvent === 'checkout') { // Checkout
            products = [];

            // Old style
            if(sqzlCommon.isDefined(ecommerce, 'checkout.products')) {
                ecommerceProducts = ecommerce.checkout.products;
            }

            products = [];

            if (ecommerceProducts !== null) {
                for (var i = 0; i < ecommerceProducts.length; i++) {
                    products.push(this.sanitizeEcommerceProduct(ecommerceProducts[i]));
                }
            }

            if(products.length > 0) {
                this.g.sqzl.q.push([{
                    event: "PrePurchase",
                    products: products,
                }]);
            }
        }
        // Purchase
        if (typeof ecommerce.purchase !== 'undefined' || ecommerceEvent === 'purchase') {
            var profile = null;

            // Old style
            if (sqzlCommon.isDefined(ecommerce, 'purchase.products')) {
                ecommerceProducts = ecommerce.purchase.products;
                var orderid = ecommerce.purchase.actionField.id;
            }

            // New style
            if (typeof ecommerce.items !== 'undefined' && typeof ecommerce.transaction_id !== 'undefined') {
                ecommerceProducts = ecommerce.items;
                var orderid = ecommerce.transaction_id;
            }

            if (ecommerceProducts !== null) {
                products = [];

                for (var i = 0; i < ecommerceProducts.length; i++) {
                    products.push(this.sanitizeEcommerceProduct(ecommerceProducts[i]));
                }

                eventData = {
                    event: "Purchase",
                    orderid: orderid,
                    products: products,
                };
                // Old style
                if(sqzlCommon.isDefined(ecommerce, 'purchase.currency')) {
                    eventData.currency = ecommerce.purchase.currency;
                }
                // New style
                else if (typeof ecommerce.currency !== 'undefined') {
                    eventData.currency = ecommerce.currency;
                }

                // Old style
                if (sqzlCommon.isDefined(ecommerce, 'purchase.profile')) {
                    profile = ecommerce.purchase.profile;
                }
                // New style
                else if (typeof ecommerce.profile !== 'undefined') {
                    profile = ecommerce.profile;
                }

                if (profile !== null) {
                    if (typeof profile.email !== 'undefined') {
                        eventData.email = profile.email;
                    }
                    if (typeof profile.firstname !== 'undefined') {
                        eventData.firstname = profile.firstname;
                    }
                    if (typeof profile.lastname !== 'undefined') {
                        eventData.lastname = profile.lastname;
                    }
                }

                this.g.sqzl.q.push([eventData]);
            }
        }
    }

    sanitizeEcommerceProduct(product) {
        // Only check for decimal/thousand separators if price is a string
        if(typeof product.price === 'string' && product.price.indexOf(',') > -1 && product.price.indexOf('.') > -1) {
            // Price should only contain decimal separators, so remove the thousand separator
            product.price = product.price.replace(',', '');
        }

        return {
            id: product.item_id || product.id || product.sku,
            name: product.item_name || product.name,
            price: product.price,
            quantity: product.quantity
        }
    }

    addSqzlListeners() {
        this.SQZLDataLayerWatcher.init();
        this.SQZLOldQueueWatcher.init();

        if(this.smartTrackingEnabled) {
            this.SQZLGoogleDataLayerWatcher.init();
        }
    }

    /**
     * This will watch the this.g._sqzl dataLayer (new way of pushing events)
     * And pushes the data to this.g.sqzl.q
     * @type {{init: *}}
     */
    SQZLDataLayerWatcher = (function(bt) {
        var pushOverwritten = false,
            originalPushFunction = false;

        var init = function() {
            this.overwritePush.call(this);
        };

        var overwritePush = function() {
            if(pushOverwritten === false) {
                bt.g._sqzl = bt.g._sqzl || [];

                if(bt.g._sqzl.length > 0) {
                    for(var i = 0; i < bt.g._sqzl.length; i++) {
                        var data = bt.g._sqzl[i];
                        data.newtracker = true;

                        bt.g.sqzl.q.push([data]);
                    }
                }

                originalPushFunction = bt.g._sqzl.push;
                bt.g._sqzl.push = this.customPush.bind(this);
                pushOverwritten = true;
            }
            else {
                setTimeout(this.overwritePush.bind(this), 250);
            }
        };

        var customPush = function() {
            var args = [].slice.call(arguments, 0);

            originalPushFunction.apply(this, args);
            for(var i in args) {
                if(!args.hasOwnProperty(i)) continue;

                var data = args[i];
                data.newtracker = true;
                bt.g.sqzl.q.push(data);
            }

            return bt.g._sqzl.length;
        };

        return {
            init,
            customPush,
            overwritePush
        };
    })(this);

    /**
     * This will watch the this.g.sqzl.q dataLayer (old trackers)
     * @type {{init: *}}
     */
    SQZLOldQueueWatcher = (function(bt) {
        var pushOverwritten = false;
        var originalPushFunction = false;

        var init = function() {
            overwritePush.apply(this);
        };

        var overwritePush = function() {
            bt.g.sqzl = bt.g.sqzl || [];
            bt.g.sqzl.q = bt.g.sqzl.q || [];

            if(pushOverwritten === false && typeof bt.g.sqzl !== 'undefined' && bt.g.sqzl.hasOwnProperty('q')) {
                originalPushFunction = bt.g.sqzl.q.push;
                bt.g.sqzl.q.push = customPush.bind(this);
                pushOverwritten = true;

                if(bt.g.sqzl.q.length > 0) {
                    for(var i = 0; i < bt.g.sqzl.q.length; i++) {
                        if(bt.g.sqzl.q[i].length > 0 && typeof bt.g.sqzl.q[i] === 'object') { // Probably an Arguments list
                            if(typeof bt.g.sqzl.q[i][0] === 'object' && !bt.g.sqzl.q[i][0].hasOwnProperty('newtracker')) {
                                bt.g.sqzl.q[i][0].oldtracker = true;
                            }
                        }
                        else if(bt.g.sqzl.q[i] && typeof bt.g.sqzl.q[i] === 'object' && bt.g.sqzl.q[i].hasOwnProperty('event') && !bt.g.sqzl.q[i].hasOwnProperty('newtracker')) {
                            bt.g.sqzl.q[i].oldtracker = true;
                        }
                    }

                    bt.checkSqzl();
                }
            }

            if(!pushOverwritten) {
                originalPushFunction = bt.g.sqzl.q.push;
                bt.g.sqzl.q.push = this.customPush.bind(this);
                pushOverwritten = true;
            }
        };

        var forceOverwritePush = function() {
            originalPushFunction = originalPushFunction || bt.g.sqzl.q.push;
            bt.g.sqzl.q.push = this.customPush.bind(this);
        };

        var customPush = function() {
            var args = [].slice.call(arguments, 0);
            for(var i = 0; i < args.length; i++) {
                if(args[i].length > 0 && typeof args[i] === 'object') { // Probably an Arguments list
                    if(typeof args[i][0] === 'object') {
                        args[i][0].oldtracker = true;
                    }
                }
                else if(args[i] && typeof args[i] === 'object' && args[i].hasOwnProperty('event') && !args[i].hasOwnProperty('newtracker')) {
                    args[i].oldtracker = true;
                }
            }

            originalPushFunction.apply(bt.g.sqzl.q, args);

            bt.checkSqzl();

            return bt.g.sqzl.q.length;
        };

        var resetItems = function() {
            bt.g.sqzl.q = [];
            // originalPushFunction = false;
            this.forceOverwritePush();
        };

        return {
            init,
            customPush,
            resetItems,
            forceOverwritePush
        };
    })(this);

    SQZLGoogleDataLayerWatcher = (function(bt) {
        var pushOverwritten = false,
            originalPushFunction = false;

        var init = function() {
            overwritePush.call(this);
        };

        var overwritePush = function() {
            if(pushOverwritten === false && typeof bt.g.dataLayer !== 'undefined') {
                if(bt.g.dataLayer.length > 0) {
                    for(var i = 0; i < bt.g.dataLayer.length; i++) {
                        var data = bt.g.dataLayer[i];

                        if(typeof data.ecommerce !== 'undefined') {
                            bt.smartTracking(data);
                        }
                    }
                }
                bt.g.sqzl.q.push([{
                    event: "PageView"
                }]);

                originalPushFunction = bt.g.dataLayer.push;
                bt.g.dataLayer.push = customPush.bind(this);
                pushOverwritten = true;
            }
            else {
                setTimeout(this.overwritePush.bind(this), 250);
            }
        };

        var customPush = function() {
            var args = [].slice.call(arguments, 0);

            originalPushFunction.apply(bt.SQZLDataLayerWatcher, args);
            for(var i in args) {
                if(!args.hasOwnProperty(i)) continue;

                var data = args[i];
                if(typeof data.ecommerce !== 'undefined') {
                    bt.smartTracking.call(bt, data);
                }
            }

            return bt.g.dataLayer.length;
        };

        return {
            init
        };
    })(this);

    /**
     *
     * @param event
     *
     * @return boolean
     */
    isDuplicateEvent(event) {
        var ignoredKeys = ['log_id', 'timestamp', 'frontend_event_id', 'oldtracker', 'newtracker'];
        var cleanData = {};

        if(event.hasOwnProperty('event') &&
            (event.event.toLowerCase() === 'reloadpersonalization' || event.event.toLowerCase() === 'pagereload')) return false;

        // Ignore unit test events
        if(event.session_id === 'test-session-id') return false;

        for(var key in event) {
            if (!event.hasOwnProperty(key)) continue;
            if (ignoredKeys.indexOf(key) > -1) continue;

            var data = event[key];

            if(key === 'originalData' && event.hasOwnProperty('type') && event.type === 'log') {
                data = data.replace(/(&)?log_id=[a-z0-9\-]+/i, ''); // remove log_id to keep it clean
            }

            cleanData[key] = data;
        }

        // encodeURIComponent since btoa can't handle non-latin1 characters
        var uniqueHash = btoa(encodeURIComponent(JSON.stringify(cleanData)));
        // var uniqueHash = btoa(encodeURIComponent(JSON.stringify(cleanData)));
        var currentTimestamp = Math.round(new Date() * 1 / 1000);
        if (
            this.duplicateEventTracker.hasOwnProperty(uniqueHash)
            && !isNaN(parseInt(this.duplicateEventTracker[uniqueHash]))
            && (currentTimestamp - parseInt(this.duplicateEventTracker[uniqueHash])) < 5
        ) {
            if(sqzlCommon.isWarningEnabled()) {
                console.warn('sqzly: Duplicate event detected in less then 5 secs. Ignoring this event', cleanData);
            }
            this.duplicateEventTracker[uniqueHash] = Math.round(new Date() * 1 / 1000);
            return true;
        }

        this.duplicateEventTracker[uniqueHash] = Math.round(new Date() * 1 / 1000);

        return false;
    }

    addPersonalizationCallback() {
        this.g.sqzl.q.unshift({
            'SetCallback': function(eventData) {
                this.g.sqzl.p.push({
                    event: 'PixelEvent',
                    eventData: eventData
                });
            }.bind(this)
        });
    }

    /**
     * @param {Date} date
     * @returns {string}
     */
    dateToIso8601String(date) {
        var year = date.getFullYear(),
            month = '' + (date.getMonth() + 1),
            day = '' + date.getDate();

        if(month.length < 2) {
            month = '0' + month;
        }
        if(day.length < 2) {
            day = '0' + day;
        }

        return [year, month, day].join('-');
    }
}